import { useRadioGroup, VStack } from '@chakra-ui/react';
import { useController, useFormContext } from 'react-hook-form';

import { RadioSelectItem } from './RadioSelectItem';

export const RadioSelect = ({
  name,
  options,
}: {
  name: string;
  options: {
    value: string;
    label: string;
  }[];
}) => {
  const { control } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const { getRootProps, getRadioProps } = useRadioGroup({
    name: name,
    value: field.value,
    onChange: field.onChange,
  });

  const group = getRootProps();

  return (
    <VStack {...group} gap={6} h="fit-content" w="full">
      {options.map(({ value, label }) => {
        const radio = getRadioProps({ value });
        return (
          <RadioSelectItem key={value} {...radio}>
            {label}
          </RadioSelectItem>
        );
      })}
    </VStack>
  );
};
